<template>
  <validation-provider
    :rules="rules"
    v-slot="{ errors }"
    :name="name"
    :immediate="immediate"
    :vid="vid"
  >
    <label v-if="label">
      {{ label }}
    </label>
    <input
      :autofocus="autofocus"
      :type="realType"
      :step="step"
      :v-mask="mask"
      :required="required"
      :disabled="disabled"
      :name="name"
      v-model="iValue"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      class="uk-form-large uk-width-1-1"
      :class="{
        'uk-form-danger': errors.length
      }"
      :readonly="readonly"
      @keydown="onKeydown"
      @change="$emit('change', $event)"
    />
    <span v-show="errors.length" class="error">{{ errors[0] }}</span>
  </validation-provider>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },
    name: {
      required: false,
    },
    margin: {
      default: false,
      required: false,
    },
    label: {
      required: false,
    },
    required: {
      default: false,
      required: false,
    },
    disabled: {
      required: false,
      default: false
    },
    rules: {
      required: false,
      default: null
    },
    immediate: {
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    maskType: {
      type: String,
      required: false,
      default: null,
    },
    step: {
      type: String,
      required: false,
      default: "",
    },
    autofocus: {
      default: false,
    },
    autocomplete: {
      type: String,
      required: false,
      default: 'chrome-off',
    },
    placeholder: {
      type: String,
    },
    maxLength: {
      type: Number,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  created() {
  },
  data() {
    return {
      masks: {
        phone:"'(###)###-####'",
        tel: "'(###)###-####'",
        text: "''",
        taxId: "'##-#######'",
        ssn: "'###-##-####'",
      }
    }
  },
  computed: {
    realType() {
      if (this.type === 'phone') {
        return 'tel';
      }
      return this.type
    },

    mask() {
      if(this.maskType === null) {
        return null;
      }
      return this.masks[this.maskType]
    },

    iValue: {
      get () { return this.value; },
      set (v) {
        this.$emit('input', v)
      },
    },

    vid() {
      return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
    },

    maxLengthReached() {
      if (this.maxLength)
        return this.iValue.length >= this.maxLength
      return false
    }
  },
  methods: {
    onKeydown(evt) {
      if (this.realType == 'email' && evt.keyCode == 32) // Disable space input in Email
      {
        evt.preventDefault()
      }
      if (this.maxLengthReached)
      {
        if (evt.keyCode >= 48 && evt.keyCode <= 90) {
          evt.preventDefault()
          return
        }
      }
    }
  }
};
</script>
